import { ref, deleteObject } from "firebase/storage";
import { storage } from "../firebase";
import { logger } from "./logger";

export const deleteImageFromUrl = async (url) => {
  try {
    const path = new URL(url).pathname;
    const cleanPath = decodeURIComponent(path.replace(/^\/v0\/b\/[^/]+\/o\//, ""));
    const imageRef = ref(storage, cleanPath);
    await deleteObject(imageRef);
    logger.log("🧹 Deleted image from storage", { value: cleanPath });
  } catch (err) {
    logger.warn("⚠️ Failed to delete image from URL", { value: err });
    throw err;
  }
};
